import { call, put, select, take, fork } from 'redux-saga/effects';
import { api } from 'rp-auth';
import {
  loadEmailConfirmationPageSuccess,
  loadEmailConfirmationPageFailure,
  EMAIL_CONFIRMATION_PAGE_LOAD_REQUESTED,
} from '../actions';
import { locationSelector } from '../../../selectors';
import { trackEmailVerification, TRAIT_OUTCOME } from 'rp-analytics';

const { confirmVerificationEmail } = api;

function waitForAnalyticsToLoad(outcome) {
  if (global.analytics) {
    trackEmailVerification({ [TRAIT_OUTCOME]: outcome });
  } else {
    setTimeout(() => {
      waitForAnalyticsToLoad(outcome);
    }, 1000);
  }
}

export function* loadEmailConfirmationPage() {
  const { search } = yield select(locationSelector);
  const searchParams = new URLSearchParams(search);
  const token = searchParams.get('token');

  try {
    if (!token) {
      throw new Error('Verification token was not provided');
    }

    yield call(confirmVerificationEmail, token);
    // we should process the response to react differently depending on particular status of verification
    // e.g. there could be different reason of failure(token was expired, or token has already been user, etc)
    yield put(loadEmailConfirmationPageSuccess());
    waitForAnalyticsToLoad('Success');
  } catch (error) {
    yield put(loadEmailConfirmationPageFailure(error));
    waitForAnalyticsToLoad('Failure');
  }
}

export function* watchLoadEmailConfirmationPage() {
  while (true) {
    yield take(EMAIL_CONFIRMATION_PAGE_LOAD_REQUESTED);
    yield fork(loadEmailConfirmationPage);
  }
}
